import React from "react";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import DashboardAccountPayableCounts from "./DashboardAccountPayableCounts";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  Autocomplete,
  Button,
  TextField,
  Grid,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Collapse,
  Box,
  Typography,
  TableCell,
  TableRow,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Error } from "@material-ui/icons";
import { dashboardStyle } from "../../Invoices/Components/InvoiceDetails/style";
import {
  ExpandMore,
  ExpandLess,
  Summarize,
} from "@mui/icons-material";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

export default function BuyerDashboard() {
  const [PayableCountsList, setPayableCounts] = useState(null);
  const [fetchedData, setFetchedData] = useState(false);
  const [monthOptions, setMonthOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [invoicesSummaryExpanded, setInvoicesSummaryExpanded] = useState(true);
  const [filter, setFilter] = useState({
    month: "",
    year: "",
    startDate: "",
    endDate: "",
  });
    const [errorMessage, setErrorMessage] = useState({
      monthError: "",
      yearError: "",
      startDateError: "",
      endDateError: "",
    });
  const[apiErrorMessage, setApiErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");


  const useStyles = makeStyles(dashboardStyle);
  const classes = useStyles();

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentMonthIndex = new Date().getMonth();
  const months = Array.from({ length: currentMonthIndex + 1 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1} - ${monthNames[i]}`,
  }));
  const currentYear = new Date().getFullYear();

  const Validyears = Array.from(
    { length: currentYear - 2023 + 1 },
    (_, i) => 2023 + i
  );
  // useEffect(() => {
  //   if (fetchedData) {
  //     fetchData();
  //   }
  // }, [fetchedData]);

  useEffect(() => {
  const selectedYear = filter?.year;
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();

  let updatedMonths = [];

  if (selectedYear) {
    const maxMonth =
    selectedYear < currentYear
          ? 12
          : selectedYear === currentYear
          ? currentMonth + 1
          : 0;
      updatedMonths = Array.from({ length: maxMonth }, (_, i) => ({
        value: i + 1,
        label: `${i + 1} - ${monthNames[i]}`,
      }));
    }
  setMonthOptions(updatedMonths);
}, [filter?.year]);

// Common function for downloading a specific card as PDF or Excel

const handleDownload = async (cardId, type, fileName) => {
  const cardElement = document.getElementById(cardId);
  if (!cardElement) return;

  // ✅ Hide elements you don’t want in export
  const hiddenElements = cardElement.querySelectorAll(".hide-on-download");
  hiddenElements.forEach((el) => (el.style.display = "none"));

  // ✅ Expand scrollable containers
  const scrollableEls = cardElement.querySelectorAll("*");
  const originalStyles = [];
  scrollableEls.forEach((el) => {
    const style = window.getComputedStyle(el);
    if (style.overflowY === "auto" || style.overflowY === "scroll") {
      originalStyles.push({
        el,
        style: {
          overflowY: el.style.overflowY,
          maxHeight: el.style.maxHeight,
          height: el.style.height,
        },
      });
      el.style.overflowY = "visible";
      el.style.maxHeight = "none";
      el.style.height = "auto";
    }
  });

  // ✅ Capture screenshot with full expanded content
  const canvas = await html2canvas(cardElement, {
    scale: 2,
    useCORS: true,
    scrollY: 0,
  });
  const imgData = canvas.toDataURL("image/png");

  // ✅ Restore original scrollable styles
  originalStyles.forEach(({ el, style }) => {
    el.style.overflowY = style.overflowY;
    el.style.maxHeight = style.maxHeight;
    el.style.height = style.height;
  });

  // ✅ Restore hidden elements
  hiddenElements.forEach((el) => (el.style.display = ""));

  // ✅ Continue with PDF or Excel export
  const monthNames = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];
  const monthName =
    typeof filter.month === "number" && filter.month >= 1 && filter.month <= 12
      ? monthNames[filter.month - 1]
      : filter.month || "N/A";

  // ------------------ PDF EXPORT ------------------
  // ------------------ PDF EXPORT (multi-page) ------------------
if (type === "pdf") {
  const pdf = new jsPDF("p", "mm", "a4");
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  const margin = 12;
  const headerHeight = 30;
  const availableY = headerHeight + margin;
  const availableHeight = pdfHeight - availableY - margin;

  // Header background
  pdf.setFillColor(230, 247, 255);
  pdf.rect(0, 0, pdfWidth, headerHeight, "F");

  // Header text
  pdf.setTextColor(30, 30, 30);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(16);
  pdf.text("Dashboard Report", pdfWidth / 2, 15, { align: "center" });

  pdf.setFontSize(12);
  pdf.setFont("helvetica", "normal");
  pdf.text(`${monthName} ${filter.year || "N/A"}`, pdfWidth / 2, 24, {
    align: "center",
  });

  // Add image (multi-page logic)
  const imgProps = pdf.getImageProperties(imgData);
  const imgWidth = pdfWidth - margin * 2;
  const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

  let heightLeft = imgHeight;
  let position = availableY;
  let pageHeightAvailable = availableHeight;

  let page = 1;

  // Loop to add pages
  while (heightLeft > 0) {
    const cropHeight = Math.min(pageHeightAvailable, heightLeft);
    const srcY = imgProps.height * (1 - heightLeft / imgHeight);
    const cropCanvas = document.createElement("canvas");
    cropCanvas.width = imgProps.width;
    cropCanvas.height = (cropHeight / imgHeight) * imgProps.height;

    const ctx = cropCanvas.getContext("2d");
    const img = new Image();
    img.src = imgData;
    await new Promise((res) => {
      img.onload = () => {
        ctx.drawImage(
          img,
          0,
          srcY,
          imgProps.width,
          cropCanvas.height,
          0,
          0,
          imgProps.width,
          cropCanvas.height
        );
        res();
      };
    });

    const pageData = cropCanvas.toDataURL("image/png");
    pdf.addImage(
      pageData,
      "PNG",
      margin,
      availableY,
      imgWidth,
      cropHeight,
      undefined,
      "FAST"
    );

    heightLeft -= pageHeightAvailable;
    if (heightLeft > 0) {
      pdf.addPage();
      page++;
    }
  }

  pdf.save(`${fileName}.pdf`);
}


  // ------------------ EXCEL EXPORT ------------------
// ------------------ EXCEL EXPORT (responsive image) ------------------
else if (type === "excel") {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Snapshot");

  // Header cells
  sheet.getCell("A1").value = "Dashboard Report";
  sheet.getCell("A1").font = { bold: true, size: 16 };
  sheet.mergeCells("A1:C1");
  sheet.getCell("A1").alignment = { horizontal: "center" };
  sheet.getCell("A2").value = `${monthName} ${filter.year || "N/A"}`;
  sheet.mergeCells("A2:C2");
  sheet.getCell("A2").alignment = { horizontal: "center" };

  // Add image below header
  const imageId = workbook.addImage({
    base64: imgData,
    extension: "png",
  });

  // Get actual image size
  const img = new Image();
  img.src = imgData;
  await new Promise((res) => (img.onload = res));

  // Convert pixel dimensions → Excel units
  const PX_TO_COL = 7.5; // Roughly: 1 Excel column ≈ 7.5 pixels
  const PX_TO_ROW = 0.75; // Roughly: 1 Excel row ≈ 0.75 pixels

  let imgWidth = img.width;
  let imgHeight = img.height;

  // ✅ Limit max width/height (for huge dashboards)
  const maxWidth = 1200;
  const maxHeight = 1600;

  if (imgWidth > maxWidth) {
    const scale = maxWidth / imgWidth;
    imgWidth *= scale;
    imgHeight *= scale;
  }
  if (imgHeight > maxHeight) {
    const scale = maxHeight / imgHeight;
    imgWidth *= scale;
    imgHeight *= scale;
  }

  // Insert image with responsive scaling
  sheet.addImage(imageId, {
    tl: { col: 0, row: 4 },
    ext: { width: imgWidth, height: imgHeight },
  });

  // Adjust row heights to fit image
  const rowsNeeded = Math.ceil(imgHeight / PX_TO_ROW / 15); // each row ~15pt height
  for (let i = 4; i < 4 + rowsNeeded; i++) {
    sheet.getRow(i).height = 15; // keeps proportion consistent
  }

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `${fileName}.xlsx`);
}

};





 const fetchAllDashboardData = async () => {
  setLoading(true);
  setFetchedData(true);

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("user_token")}`,
  };

  const month = filter?.month;
  const year = filter?.year;
  const baseUrl = process.env.REACT_APP_API_URL;

  try {
    const [
      payableCountsRes,
      ,
    ] = await Promise.all([
      axios.get(`${baseUrl}/api/Dashboard/DashboardAccountPayableCounts?fromDate=${filter.startDate}&toDate=${filter.endDate}`, { headers }),
    ]);

    // ✅ Update all your states here
    setPayableCounts(payableCountsRes?.data?.response?.[0]);
    setSuccessMessage("Dashboard data fetched successfully");

  } catch (error) {
    setPayableCounts(null);
    setApiErrorMessage('Failed to fetch dashboard data. Please try again.');
  } finally {
    setLoading(false);
    setFetchedData(false);
  }
};

  // const changeHandler = (name, value) => {
  // const now = new Date();
  // const currentYear = now.getFullYear();
  // const currentMonth = now.getMonth() + 1;
  // if(name === "month"){
  //   if (!filter?.year) {
  //     setErrorMessage({
  //       ...errorMessage,
  //       monthError: "Please select year first",
  //     });
  //     return;
  //   }
  //   if (filter.year > currentYear || 
  //       (filter.year == currentYear && value > currentMonth)) {
  //     setErrorMessage({
  //       ...errorMessage,
  //       monthError: "Invalid month for selected year",
  //     });
  //     return;
  //   }
  //   setFilter({
  //       ...filter, 
  //       month : value,
  //     });
  //     if(value !== null || value !== "") {
  //       setErrorMessage({
  //         ...errorMessage,
  //         monthError: "",
  //       });
  //     }
  //   }
  //  if (name === "year") {
  // setFilter({
  //   ...filter, 
  //   year: value,
  //   month: "",
  // });

  //     if(value !== null || value !== ""){
  //       setErrorMessage({
  //         ...errorMessage,
  //         yearError: "",
  //       });
  //     }
  //   }
  // };
const changeHandler = (name, value) => {
  if (name === "startDate") {
    setFilter({
      ...filter,
      startDate: value,
      endDate: "", // reset end date when start date changes
    });
    setErrorMessage({
      ...errorMessage,
      startDateError: "",
      endDateError: "",
    });
  }

  if (name === "endDate") {
    // Validate end date is not before start date
    if (filter.startDate && new Date(value) < new Date(filter.startDate)) {
      setErrorMessage({
        ...errorMessage,
        endDateError: "End date cannot be earlier than start date",
      });
      return;
    }

    setFilter({
      ...filter,
      endDate: value,
    });

    setErrorMessage({
      ...errorMessage,
      endDateError: "",
    });
  }
};

// const filterHandler = () => {
//   if (!filter?.year) {
//     setErrorMessage({
//       ...errorMessage,
//       yearError: "Please Select Year",
//     });
//     return;
//   }

//   if (!filter?.month) {
//     setErrorMessage({
//       ...errorMessage,
//       monthError: "Please Select Month",
//     });
//     return;
//   }

//   // Errors clear
//   setErrorMessage({
//     ...errorMessage,
//     monthError: "",
//     yearError: "",
//   });

//   // Loading state
//   setFetchedData(true);

//   // fetchPayableCounts();
//   fetchAllDashboardData();
// };
const filterHandler = () => {
  if (!filter?.startDate) {
    setErrorMessage({
      ...errorMessage,
      startDateError: "Please select start date",
    });
    return;
  }

  if (!filter?.endDate) {
    setErrorMessage({
      ...errorMessage,
      endDateError: "Please select end date",
    });
    return;
  }

  // End date should not be before start date
  if (new Date(filter.endDate) < new Date(filter.startDate)) {
    setErrorMessage({
      ...errorMessage,
      endDateError: "End date cannot be earlier than start date",
    });
    return;
  }

  // Clear errors
  setErrorMessage({
    ...errorMessage,
    startDateError: "",
    endDateError: "",
  });

  // Loading state
  setFetchedData(true);

  fetchAllDashboardData();
};

  const [anchorEl, setAnchorEl] = useState(null);

const openGuideInNewTab = () => {
  const baseUrl = window.location.origin;
  const pdfUrl = `/dashboardmanual/home.html`;
  const fullUrl = `${baseUrl}${pdfUrl}`;
  window.open(fullUrl, '_blank');
};






  return (
    <>
      <div
        style={{
          backgroundColor: "#eee",
          minHeight: "inherit",
          padding: "8px",
          paddingTop: "16px",
          boxSizing: "border-box" // Prevent overflow
        }}
      >
             {/* Loader overlay with blur */}
        {loading && (
          <div
            aria-hidden={!loading}
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 1400,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255,255,255,0.35)", // light veil so backdrop-filter shows
              backdropFilter: "blur(6px)",
              WebkitBackdropFilter: "blur(6px)", // Safari
            }}
          >
        <div style={{ textAlign: "center" }}>
  <CircularProgress sx={{ color: "#009FE3" }} />
  <div style={{ marginTop: 12, color: "#009FE3", fontWeight: 500 }}>
    Loading
  </div>
</div>

          </div>
        )}
        <Grid
          container
          spacing={2}
          sx={{marginBottom: 2,px: { xs: 2, sm: 4, md: 4},}}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}> 
            <Card sx={{ 
              overflow: "hidden", // Prevent content overflow
              margin: "0 auto" // Center the card
            }}>
              <CardContent
              sx={{ 
              p: { xs: 1.5, sm: 2, md: 3 }, // More controlled padding
              "&:last-child": { pb: { xs: 1.5, sm: 2, md: 3 } } // Fix bottom padding issue
            }}>
                <Grid container spacing={{ xs: 1.5, sm: 2, md: 3 }} alignItems="flex-end"> {/* Tighter spacing on mobile */}             
                  {/* Year */}
                  {/* <Grid item xs={12} sm={6} md={4}>
                    <Typography 
                      sx={{ 
                      fontSize: { xs: "14px", sm: "16px" },
                      fontWeight: 500,
                       mb: 1
                     }}
                    >
                      Year
                    </Typography>
                    <Autocomplete
                      sx={{
                        "& .MuiInputBase-root": {
                          height: { xs: "36px", sm: "40px" },
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiInputBase-input": {
                          marginTop: "-4px",
                          fontSize: { xs: "14px", sm: "15px" },
                        },
                      }}
                      id="year-select"
                      options={Validyears}
                      size="small"
                      name="year"
                      getOptionLabel={(option) => option.toString()}
                      onChange={(event, newValue) => {
                        changeHandler("year", newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          placeholder="Select Year"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                    {errorMessage?.yearError && (
                      <Grid container spacing={0} 
                      sx={{ 
                        mt: 0.5,
                        alignItems: "center"
                      }}
                    >
                        <Grid item>
                          <Error
                            titleAccess="Error"
                            className={classes.asterisk}
                            fontSize="small"
                          />
                        </Grid>
                        <Grid item>
                          <Typography className={classes.asterisk} 
                          sx={{ 
                            ml: 1,
                            fontSize: { xs: "12px", sm: "14px" } // Responsive error text
                          }}
                        >
                            {errorMessage?.yearError}
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                  </Grid> */}

                  {/* Month */}
                  {/* <Grid item xs={12} sm={6} md={4}>
                    <Typography 
                    sx={{ 
                      fontSize: { xs: "14px", sm: "16px" },
                      fontWeight: 500,
                      mb: 1
                    }}
                  >
                    Month
                  </Typography>
                    <Autocomplete
                      sx={{
                        "& .MuiInputBase-root": {
                          height: { xs: "36px", sm: "40px" },
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiInputBase-input": {
                          marginTop: "-4px",
                      fontSize: { xs: "14px", sm: "15px" },
                        },
                      }}
                      options={monthOptions}
                      disabled={!filter?.year}
                      size="small"
                      name="month"
                      value={
                        monthOptions.find(
                          (option) => option.value === filter?.month
                        ) || null
                      }
                      getOptionLabel={(option) => option?.label || ""}
                      isOptionEqualToValue={(option, value) =>
                        option?.value === value
                      }
                      onChange={(event, newValue) => {
                        changeHandler("month", newValue?.value || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                        placeholder="Select Month"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                    {errorMessage?.monthError && (
                      <Grid 
                      container 
                      spacing={0} 
                      sx={{ 
                        mt: 0.5,
                        alignItems: "center"
                      }}
                    >
                        <Grid item>
                          <Error
                            titleAccess="Error"
                            className={classes.asterisk}
                            fontSize="small"
                          />
                        </Grid>
                        <Grid item>
                          <Typography 
                          className={classes.asterisk} 
                          sx={{ 
                            ml: 1,
                            fontSize: { xs: "12px", sm: "14px" }
                          }}
                        >
                            {errorMessage?.monthError}
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                  </Grid> */}
 <Grid item xs={12} sm={6} md={4}>
          <Typography>
            Start Date:
          </Typography>
          <TextField
            type="date"
            variant="outlined"
            fullWidth
            size="small"
            value={filter?.startDate || ""}
            onChange={(e) => {
              changeHandler("startDate", e.target.value);
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          {errorMessage?.startDateError && (
            <Grid container spacing={0} sx={{ mt: 0.5, alignItems: "center" }}>
              <Grid item>
                <Error
                  titleAccess="Error"
                  className={classes.asterisk}
                  fontSize="small"
                />
              </Grid>
              <Grid item>
                <Typography
                  className={classes.asterisk}
                  sx={{
                    ml: 1,
                    fontSize: { xs: "12px", sm: "14px" },
                  }}
                >
                  {errorMessage?.startDateError}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography>
            End Date:
          </Typography>
          <TextField
            fullWidth
            size="small"
            type="date"
            variant="outlined"
            value={filter?.endDate || ""}
            onChange={(e) => {
              changeHandler("endDate", e.target.value);
            }}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: "10px" }}
          />
          {errorMessage?.endDateError && (
            <Grid container spacing={0} sx={{ mt: 0.5, alignItems: "center" }}>
              <Grid item>
                <Error
                  titleAccess="Error"
                  className={classes.asterisk}
                  fontSize="small"
                />
              </Grid>
              <Grid item>
                <Typography
                  className={classes.asterisk}
                  sx={{
                    ml: 1,
                    fontSize: { xs: "12px", sm: "14px" },
                  }}
                >
                  {errorMessage?.endDateError}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>
                  {/* Button */}
                  <Grid item xs={12} sm={12} md={2}>
                    <Button
                      fullWidth
                      sx={{
                        height: { xs: "36px", sm: "40px" }, // Responsive button height
                        color: "white",
                        backgroundColor: "rgb(0, 149, 218)",
                      fontSize: { xs: "14px", sm: "16px" }, // Responsive font size
                      fontWeight: 500,
                      "&:hover": {
                        backgroundColor: "rgb(0, 130, 190)",
                      },
                      mt: { xs: 1, md: 0 } // Add margin top on mobile, none on desktop
                      }}
                      variant="contained"
                      color="secondary"
                      type="submit"
                      id="proceed"
                      onClick={filterHandler}
                    >
                      Filter
                    </Button>
                  </Grid>
                    <Grid item xs={12} sm={12} md={2}>
                                      <Button
                                        fullWidth
                                        sx={{
                                          height: { xs: "36px", sm: "40px" }, // Responsive button height
                                          color: "white",
                                          backgroundColor: "rgb(12, 138, 37)",
                                        fontSize: { xs: "14px", sm: "16px" }, // Responsive font size
                                        fontWeight: 500,
                                        "&:hover": {
                                          backgroundColor: "rgb(21, 113, 39)",
                                        },
                                        mt: { xs: 1, md: 0 } // Add margin top on mobile, none on desktop
                                        }}
                                        variant="contained"
                                        color="secondary"
                                        type="button"
                                        id="proceed"
                                        onClick={openGuideInNewTab}
                                      >
                                        Guide
                                      </Button>
                                    </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
 <Grid item  sx={{ marginTop: "50px" }} xs={12} sm={12} md={12} lg={12} xl={12}>
            <Card id="invoiceSummaryCard"
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box className="hide-on-download" 
                sx={{
                  background: "linear-gradient(60deg, #66bb6a, #43a047)",
                  boxShadow:
                    "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(67, 160, 71, .4)",
                  position: "absolute",
                  top: "-35px", // pushes icon box half above card
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <Summarize sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{
                  marginTop: "-30px",
                  paddingLeft: "100px",
                }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px", 
                minHeight: "48px",
                lineHeight: "24px", }}
                title="Invoices Summary"
                action={
                  <>
                    {/* Expand/Collapse button */}
                    <IconButton onClick={() => setInvoicesSummaryExpanded(prev => !prev)}>
                      {invoicesSummaryExpanded ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>

                    {/* 3-dot menu */}
                    {invoicesSummaryExpanded &&
                    <IconButton className="hide-on-download" onClick={(e) => setAnchorEl(e.currentTarget)}>
                      <MoreVertIcon />
                    </IconButton>}
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={() => setAnchorEl(null)}
                    >
                      <MenuItem
                        onClick={() => {
                          handleDownload("invoiceSummaryCard", "pdf", "Invoices_Summary");
                          setAnchorEl(null);
                        }}
                      >
                        <PictureAsPdfIcon sx={{ mr: 1 }} /> Download PDF
                      </MenuItem>
                      {/* <MenuItem
                        onClick={() => {
                          handleDownload("invoiceSummaryCard", "excel", "Invoices_Summary");
                          setAnchorEl(null);
                        }}
                      >
                        <InsertDriveFileIcon sx={{ mr: 1 }} /> Download Excel
                      </MenuItem> */}
                    </Menu>
                  </>
                }
              />
              <Collapse in={invoicesSummaryExpanded} timeout="auto">
                <CardContent>
                  <DashboardAccountPayableCounts PayableCountsList={PayableCountsList} />
                </CardContent>
              </Collapse>
            </Card>
            </Grid>
       


      </div>
    </>
  );
}
